import { Box, CircularProgress, Stack } from '@mui/material'
import { i18nTranslationHelper } from '@/i18n'

interface SpinnerProps {
  fullScreen?: boolean
}

export default function Spinner({ fullScreen = false }: SpinnerProps) {
  const t = i18nTranslationHelper.getTComponents

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: 'flex',
        position: fullScreen ? 'fixed' : 'relative',
        justifyContent: 'center',
        alignItems: 'center',
        top: 0,
        left: 0,
        bgcolor: '#fff',
        zIndex: 10,
        width: '100%',
        height: '100%'
      }}
    >
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={80}
        width="100%"
        data-testid="spinner"
      >
        <CircularProgress aria-label={t('accessibility.loadingContent')} />
        <span className="sr-only">{t('accessibility.loading')}</span>
      </Stack>
    </Box>
  )
}
